module.exports = __webpack_public_path__ + "img/noticias.7af8386f.png";